import React, { useEffect, useRef } from 'react'

export interface PixModalProps {
  open: boolean
  onClose: () => void
  pixCode: string
  /** URL da imagem do QR Code ou data URI */
  qrCodeUrl?: string
}

const PixModal: React.FC<PixModalProps> = ({ open, onClose, pixCode, qrCodeUrl }) => {
  const modalRef = useRef<HTMLDivElement>(null)
  const closeBtnRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    if (open) {
      document.addEventListener('keydown', handleKeyDown)
      document.body.classList.add('modal-open')
      setTimeout(() => closeBtnRef.current?.focus(), 0)
      modalRef.current?.focus()
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.classList.remove('modal-open')
    }
  }, [open, onClose])

  if (!open) return null

  const handleBackdrop = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pixCode)
    } catch {
      // ignore
    }
  }

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose} />
      <div
        className="modal fade show d-block"
        role="dialog"
        tabIndex={-1}
        ref={modalRef}
        onMouseDown={handleBackdrop}
        style={{ overflow: 'auto' }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document" onMouseDown={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title w-100 text-center">Pagamento via PIX</h5>
              <button type="button" className="btn-close" aria-label="Fechar" onClick={onClose} ref={closeBtnRef} />
            </div>
            <div className="modal-body text-center">
              {qrCodeUrl && (
                <img src={qrCodeUrl} alt="QR Code PIX" className="img-fluid mb-3" style={{ maxWidth: 200 }} />
              )}
              {!qrCodeUrl && !pixCode.startsWith('http') && (
                <div className="mb-3">
                  <i className="bi bi-qr-code display-1 text-primary"></i>
                </div>
              )}
              {pixCode.startsWith('http') ? (
                <div>
                  <p className="text-grey-600 mb-3">
                    O QR Code PIX não está disponível neste ambiente. Use o link abaixo para concluir o pagamento:
                  </p>
                  <a href={pixCode} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary w-100 mb-2">
                    <i className="bi bi-box-arrow-up-right me-2"></i>Abrir página de pagamento
                  </a>
                </div>
              ) : (
                <>
                  <p className="text-grey-600 mb-2">Copie o código abaixo e cole no app do seu banco:</p>
                  <div className="input-group">
                    <input type="text" className="form-control" readOnly value={pixCode} />
                    <button type="button" className="btn btn-outline-secondary" onClick={handleCopy}>
                      <i className="bi bi-clipboard me-1"></i>Copiar
                    </button>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary ms-auto" onClick={onClose}>
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PixModal
